/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import * as React from 'react';

import { Flex } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { IconButton, makeStyles } from '@material-ui/core';
import { baseTheme } from 'themes/clients/baseTheme';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { combine } from '../utils';

const useStyles = makeStyles((theme) => ({
  leftBorderRadius: {
    borderRadius: '50% 0 0 50%',
  },
  rightBorderRadius: {
    borderRadius: '0 50% 50% 0',
  },
  buttonContainer: {
    display: 'flex',
  },
  button: {
    height: 40,
    width: 40,
    padding: 0,
  },
  buttonText: {
    lineHeight: 1.6,
  },
  outlined: {
    border: `1px solid ${theme.palette.primary.dark}`,
  },
  filled: {
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
    backgroundColor: theme.palette.primary.dark,
  },
  highlighted: {
    backgroundColor: baseTheme.colors.feedback.D6E7F9,
  },
  contrast: {
    color: theme.palette.primary.contrastText,
  },
}));

const Day = ({
  startOfRange,
  endOfRange,
  disabled,
  highlighted,
  outlined,
  filled,
  onClick,
  onHover,
  value,
  isToday,
  isStart,
  isEnd,
}) => {
  const classes = useStyles();

  return (
    <div
      className={combine(
        classes.buttonContainer,
        startOfRange && classes.leftBorderRadius,
        endOfRange && classes.rightBorderRadius,
        !disabled && highlighted && classes.highlighted
      )}
      style={{ marginTop: '8px' }}
    >
      <StyledDayButton
        className={combine(classes.button, !disabled && filled && classes.filled)}
        disabled={disabled}
        onClick={onClick}
        onMouseOver={onHover}
        isStart={isStart}
        isEnd={isEnd}
      >
        <Flex flexDir="column" alignItems="center" position="relative">
          <TextBodyMedium
            bold
            color={
              isStart || isEnd ? '#fff' : isToday || highlighted ? 'primary.1565BC' : !disabled ? 'text.g1' : 'text.g3'
            }
            className={combine(classes.buttonText, !disabled && filled && classes.contrast)}
          >
            {value}
          </TextBodyMedium>
          {isToday && <Dot />}
        </Flex>
      </StyledDayButton>
    </div>
  );
};

const Dot = styled.div`
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.colors.functional['1565BC']};
  position: absolute;
  bottom: 0;
`;

const StyledDayButton = styled(IconButton)`
  background-color: ${(props) => (props.isStart || props.isEnd ? props.theme.colors.primary['1565BC'] : 'transparent')};
  border-radius: ${(props) => (props.isStart ? '4px 0px 0px 4px' : props.isEnd ? ' 0px 4px 4px 0px' : '0')};
`;

export default Day;
